import type { IContact } from "@bbj-types/contact";
import { Typography } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { classes } from "./styles";

export interface IContactFormTitleProps {
  value: Partial<IContact>;
}

export const ContactFormTitle = ({ value }: IContactFormTitleProps) => {
  return (
    <Typography variant="body1" className={classes.blackTitle}>
      {(Boolean(value.firstName) || Boolean(value.lastName)) && (
        <Typography variant="body1SemiBold">
          {value.firstName} {value.lastName} •&nbsp;
        </Typography>
      )}
      {value.email}
      {Boolean(value.email && value.phone) && " • "}
      {formatPhoneNumber(value.phone)}
    </Typography>
  );
};
